import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import '../../styles/YatasYatak.css';
import { FaWhatsapp, FaTimes } from "react-icons/fa";

const YatasYatak = () => {
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [isDetailOpen, setIsDetailOpen] = useState(false);
  
  useEffect(() => {
    // URL'deki hash'i kontrol et ve ilgili bölüme scroll et
    if (window.location.hash) {
      const element = document.getElementById(window.location.hash.substring(1));
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }
    }
  }, []);

    const handleProductClick = (productId) => {
    // Ürün bilgisinin var olup olmadığını kontrol et
    if (products[productId]) {
      setSelectedProduct(productId);
      setIsDetailOpen(true);
      document.body.style.overflow = 'hidden'; // Scroll'u engelle
    } else {
      console.error('Ürün bulunamadı:', productId);
    }
  };

  const closeDetail = () => {
    setIsDetailOpen(false);
    setSelectedProduct(null);
    document.body.style.overflow = 'auto'; // Scroll'u geri aç
  };

    // Ürün bilgileri
  const products = {
    'black-ice-set': {
      name: 'Black Ice 3’lü Set (Yatak + Baza + Başlık)',
      image: '../files/black-ice-set.webp',
      description: 'Üst düzey konforunun yanı sıra serinletici etkili siyah kumaşı ile fark yaratan Black Ice Yatak, özel olarak tasarlanmış Black Ice Baza ve Başlık ile yatak odalarınızda estetik ve şık bir tarz yaratıyor. Propocket 2.1 yay sistemi ile daha sert ve güçlü bir yatak yüzeyi, Copper Cool teknolojisi ile terlemeyi azaltan ve uykuya dalma süresini kısaltan bakır molekülleri, modern ve estetik baza-başlık tasarımı ile bütünsel bir şıklık ve konfor.',
      price: "66.730,00 ₺'den başlayan fiyatlarla",
      features: [
        'Serinletici etkili siyah kumaş',
        'Propocket 2.1 yay sistemi (daha kalın ve güçlü yaylar)',
        'Copper Cool teknolojisi (bakır molekülleri ile terlemeyi azaltır)',
        'Sırt ve bel bölgesine özel destek',
        'Sert yatak yüzeyi',
        'Modern ve estetik baza & başlık',
        'Üst düzey konfor',
        'Bütünsel şıklık',
      ],
      dimensions: 'Farklı ölçülerde set seçenekleri',
      material: 'Siyah özel kumaş, bakır molekülleri',
      warranty: '2 Yıl Garanti',
    },
    'supreme-star-set': {
      name: 'Supreme Star 3’lü Set (Yatak + Baza + Başlık)',
      image: '../files/supreme-star-set.webp',
      description: 'Visco katmanı ile uyku konforunu üst düzeye çıkaran Supreme Star Yatak, estetik tasarım detaylarına sahip Supreme Sleep Başlık ve Lento Baza ile sade ve modern bir uyum sergiler. Açık hücreli visco sünger, omurganın doğal eğrisinin korunmasına yardımcı olur ve vücudu doğru şekilde sararak uyku esnasında istem dışı dönme hareketlerini azaltır. Yüksek hava geçirgenliği ile ferah bir uyku ortamı sunar. Yataş’a özel çift tavlanmış çelik yaylardan oluşan DHT Yay Teknolojisi ile Supreme Star Yatak, yıllara meydan okur. DHT Yay Sistemi, tek taraflı kullanımlarda bile yatağınızın uzun yıllar boyunca ilk günkü formunda kalmasını sağlar. Uluslararası dayanıklılık testlerinden başarılı sonuçlar elde etmiştir.',
      price: "12.990,00 ₺'den başlayan fiyatlarla",
      features: [
        'Açık hücreli visco sünger katmanı',
        'Omurganın doğal eğrisini koruyan yapı',
        'Yüksek hava geçirgenliği',
        'DHT Yay Teknolojisi (çift tavlanmış çelik yaylar)',
        'Uzun ömürlü ve formunu koruyan yatak',
        'Modern ve estetik baza & başlık',
        'Sade ve şık tasarım',
      ],
      dimensions: 'Farklı ölçülerde set seçenekleri',
      material: 'Visco sünger, DHT yay sistemi',
      warranty: '2 Yıl Garanti',
    },
    'athletic-set': {
      name: "Athletic 3'lü Set (Yatak + Baza + Başlık)",
      image: '../files/athletic-set.webp',
      description: "Profesyonel sporcular ve aktif spor yapanların destekçisi Athletic Yatak, zamansız tasarımıyla yatak odalarının konforlu ve fonksiyonel parçası olan Barte baza ve başlık ile yatak odalarında aranan uyumu sergiliyor. İnsan vücudundan çevreye yayılan enerjiyi emerek vücudun kullanabileceği bir formda dokulara geri kazandıran Athletic Yatak, doku altı oksijen miktarını arttırarak vücut sıcaklığını düzenlerken kan dolaşımını iyileştirir. Skolyoz problemi yaşayan kişiler özelinde yapılan yaşam kalitesi testlerinde, Athletic Yatak kullanan kişilerin yaşam kalitesi skorlarının daha iyi olduğu kanıtlanmıştır. Athletic Yatak kullanan gruptaki skolyoz probleminin düzelme oranının, diğer yatakları kullanan gruptan fazla olduğu görülmüştür. Barte Baza'nın yüksek metal ayağı temizlikte kolaylık sağlarken Barte Başlık, yumuşak ve rahat yapısı sayesinde sırtınıza destek veriyor. Barte Baza & Başlık ve Athletic Yatak'ın uyumu, yatak odalarınızda fonksiyonelliği ve konforu yaratıyor.",
      price: "44.670,00 ₺'den başlayan fiyatlarla",
      features: [
        'Enerji geri kazandırıcı Athletic Yatak',
        'Doku altı oksijen miktarını artıran teknoloji',
        'Vücut sıcaklığı ve kan dolaşımını düzenler',
        'Skolyoz için klinik olarak test edilmiş',
        'Barte Baza: yüksek metal ayak, kolay temizlik',
        'Barte Başlık: yumuşak ve rahat, sırt desteği',
        'Modern ve fonksiyonel tasarım',
      ],
      dimensions: 'Farklı ölçülerde set seçenekleri',
      material: 'Enerji transferli yatak kumaşı',
      warranty: '2 Yıl Garanti',
    },
    'shelly-nevresim': {
      name: "Shelly Nevresim Takımı",
      image: '../files/shelly-nevresim.webp',
      description: "Shelly Nevresim Takımı, %60 Bambu, %40 Pamuk saten dokuması ile nefes alabilir, yumuşak ve konforlu bir uyku deneyimi sunar. Modern desenleriyle yatak odanıza şıklık katar. Kolay yıkanabilir, uzun ömürlü ve hipoalerjenik yapısı ile hassas ciltler için idealdir.",
      price: "1.799,00 ₺'den başlayan fiyatlarla",
      features: [
        '%60 Bambu, %40 Pamuk saten dokuması',
        'Nefes alabilir ve yumuşak doku',
        'Modern ve zarif desenler',
        'Kolay yıkanabilir',
        'Uzun ömürlü kullanım',
        'Hipoalerjenik ve hassas ciltlere uygun',
        'Çift kişilik ve tek kişilik ebat seçenekleri',
      ],
      dimensions: 'Çift Kişilik / Tek Kişilik',
      material: '%60 Bambu, %40 Pamuk saten dokuması',
      warranty: '2 Yıl Garanti',
    },
    'katrina-nevresim': {
      name: "Katrina Nevresim Takımı",
      image: '../files/katrina-nevresim.webp',
      description: "%100 pamuk saten kumaş kalitesiyle ideal uyku konforu sunan Katrina Saten Nevresim Takımı, klasik çiçek desenlerini vintage tarzın zamansız şıklığıyla buluştururken, volanlı yastık kılıflarıyla zengin görselliğini tamamlar.",
      price: "1.899,00 ₺'den başlayan fiyatlarla",
      features: [
        '%100 pamuk saten kumaş',
        'Klasik çiçek desenleri',
        'Vintage tarz ve zamansız şıklık',
        'Volanlı yastık kılıfları',
        'Ekstra yumuşak ve konforlu doku',
        'Uzun ömürlü ve dayanıklı',
        'Kolay yıkanabilir',
      ],
      dimensions: 'Çift Kişilik / Tek Kişilik',
      material: '%100 pamuk saten',
      warranty: '2 Yıl Garanti',
    },
    'merri-nevresim': {
      name: "Merri Ranforce Pike Takımı",
      image: '../files/merri-nevresim.webp',
      description: "Merri Ranforce Pike Takımı, çiçek desenleri, kiremit ve beyazın hoş uyumuyla sofistike bir yatak odası oluşturur. %100 Pamuk kumaş kalitesi ve 57 tel dokuma sıklığı ile ideal uyku konforu sunar. Volanlı yastık kılıfları, sadece konforu değil aynı zamanda estetiği de ön planda tutar. Çiçek desenleri ve renklerin armonisiyle yatak odalarına dekoratif bir dokunuş katar.",
      price: "999,00 ₺'den başlayan fiyatlarla",
      features: [
        '%100 pamuk kumaş',
        '57 tel dokuma sıklığı',
        'Kiremit ve beyaz renk uyumu',
        'Çiçek desenleriyle dekoratif görünüm',
        'Volanlı yastık kılıfları',
        'Ekstra yumuşak ve konforlu doku',
        'Uzun ömürlü ve dayanıklı',
        'Kolay yıkanabilir',
      ],
      dimensions: 'Çift Kişilik / Tek Kişilik',
      material: '%100 pamuk kumaş',
      warranty: '2 Yıl Garanti',
    },
  }

  return (
    <div className="yatas-yatak">
      <Header />
      
      <main className="main-content">
        {/* Hero Section */}
        <section className="page-hero">
          <div className="hero-overlay"></div>
          <div className="hero-content">
            <div className="brand-logo">
              <img src="../files/yatas-logo.png" alt="Yataş Yatak Logo" />
            </div>
            <h1>Yataş Yatak Koleksiyonu</h1>
            <p>Kaliteli uyku ve konfor için premium yatak çözümleri</p>
          </div>
        </section>

        {/* Products Section */}
        <section className="products-section">
          <div className="container">
            <h2>Yatak Kategorilerimiz</h2>

            {/* Yatak, Baza, Başlık Setleri */}
            <div className="category-section" id="yatak">
              <h3 className="category-title">🛏️ Yatak, Baza, Başlık Setleri</h3>
              <div className="products-grid">
                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/black-ice-set.webp" alt="Yataş Yatak 1" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('black-ice-set')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>Black Ice 3'lü Set</h4>
                    <p>Serinletici siyah kumaş, Propocket 2.1 yay sistemi ve Copper Cool teknolojisi</p>
                    <div className="product-features">
                      <span className="feature">✓ Serinletici etkili siyah kumaş</span>
                      <span className="feature">✓ Propocket 2.1 yay sistemi</span>
                      <span className="feature">✓ Modern baza & başlık</span>
                    </div>
                    <div className="product-price">
                      <span className="price">66.730,00 ₺</span>
                    </div>
                  </div>
                </div>

                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/supreme-star-set.webp" alt="Yataş Yatak 2" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('supreme-star-set')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>Supreme Star 3'lü Set</h4>
                    <p>Visco katmanı, DHT yay teknolojisi ve modern tasarımı ile üst düzey konfor</p>
                    <div className="product-features">
                      <span className="feature">✓ Açık hücreli visco sünger</span>
                      <span className="feature">✓ DHT Yay Teknolojisi</span>
                      <span className="feature">✓ Yüksek hava geçirgenliği</span>
                    </div>
                    <div className="product-price">
                      <span className="price">12.990,00 ₺</span>
                    </div>
                  </div>
                </div>

                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/athletic-set.webp" alt="Yataş Yatak 3" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('athletic-set')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>Athletic 3'lü Set</h4>
                    <p>Enerji geri kazandırıcı Athletic Yatak, Barte baza ve başlık</p>
                    <div className="product-features">
                      <span className="feature">✓ Doku altı oksijen miktarını artıran teknoloji</span>
                      <span className="feature">✓ Vücut sıcaklığı ve kan dolaşımını düzenler</span>
                      <span className="feature">✓ Skolyoz için klinik olarak test edilmiş</span>
                    </div>
                    <div className="product-price">
                      <span className="price">44.670,00 ₺</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Tekstil */}
            <div className="category-section" id="tekstil">
              <h3 className="category-title">🧵 Tekstil</h3>
              <div className="products-grid">
                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/shelly-nevresim.webp" alt="Shelly Nevresim Takımı" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('shelly-nevresim')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>Shelly Nevresim Takımı</h4>
                    <p>Bambu ve pamuk saten dokuma, modern desen ve yumuşak doku</p>
                    <div className="product-features">
                      <span className="feature">✓ Pamuk ve bambu dokuma</span>
                      <span className="feature">✓ Modern desen</span>
                      <span className="feature">✓ Hipoalerjenik</span>
                    </div>
                    <div className="product-price">
                      <span className="price">1.799,00 ₺</span>
                    </div>
                  </div>
                </div>

                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/katrina-nevresim.webp" alt="Katrina Saten Nevresim Takımı" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('katrina-nevresim')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>Katrina Nevresim Takımı</h4>
                    <p>%100 pamuk saten kumaş ve volanlı yastık kılıfları ile zamansız şıklık</p>
                    <div className="product-features">
                      <span className="feature">✓ %100 pamuk saten</span>
                      <span className="feature">✓ Vintage çiçek desenleri</span>
                      <span className="feature">✓ Volanlı yastık kılıfı</span>
                    </div>
                    <div className="product-price">
                      <span className="price">1.899,00 ₺</span>
                    </div>
                  </div>
                </div>

                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/merri-nevresim.webp" alt="Yataş Tekstil 3" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('merri-nevresim')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>Merri Ranforce Pike Takımı</h4>
                    <p>%100 pamuk kumaş ve volanlı yastık kılıfları ile dekoratif ve konforlu</p>
                    <div className="product-features">
                      <span className="feature">✓ %100 pamuk</span>
                      <span className="feature">✓ Çiçek desenleri</span>
                      <span className="feature">✓ Volanlı yastık kılıfı</span>
                    </div>
                    <div className="product-price">
                      <span className="price">999,00 ₺</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </section>

        {/* Features Section */}
        <section className="features-section">
          <div className="container">
            <h2>Yataş Yatak Avantajları</h2>
            <div className="features-grid">
              <div className="feature-item">
                <div className="feature-icon">🏆</div>
                <h3>60 Yıllık Deneyim</h3>
                <p>Türkiye'nin en köklü yatak markası</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🔬</div>
                <h3>Ar-Ge Merkezi</h3>
                <p>Sürekli araştırma ve geliştirme</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🌿</div>
                <h3>Doğal Malzemeler</h3>
                <p>Çevre dostu ve sağlıklı malzemeler</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">💤</div>
                <h3>Uyku Uzmanı</h3>
                <p>Kaliteli uyku için bilimsel yaklaşım</p>
              </div>
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section className="contact-section">
          <div className="container">
            <div className="contact-content">
              <h2>Daha Fazlası İçin Bizimle İletişime Geçin</h2>
              <p>Yataş Yatak ürünleri hakkında detaylı bilgi almak ve fiyat teklifi için bize ulaşın.</p>
              <div className="contact-buttons">
                <a href="tel:+905496250335" className="btn btn-primary">📞 Hemen Ara</a>
                <a href="https://wa.me/905496250335" target="_blank" rel="noopener noreferrer" className="btn btn-secondary">
                  <FaWhatsapp style={{ marginRight: 8, fontSize: 20, verticalAlign: 'middle' }} />
                  WhatsApp
                </a>
                <Link to="/kurumsal" className="btn btn-outline">🏪 Mağazamızı Ziyaret Edin</Link>
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* Product Detail Modal */}
      {isDetailOpen && selectedProduct && products[selectedProduct] && (
        <div className="product-detail-modal">
          <div className="modal-overlay" onClick={closeDetail}></div>
          <div className="modal-content">
            <button className="close-button" onClick={closeDetail}>
              <FaTimes />
            </button>
            
            <div className="modal-body">
              <div className="product-image-section">
                <img 
                  src={products[selectedProduct]?.image || '../files/traverta-yatak-odasi.webp'} 
                  alt={products[selectedProduct]?.name || 'Ürün'}
                  className="detail-image"
                />
              </div>
              
              <div className="product-info-section">
                <h2>{products[selectedProduct]?.name || 'Ürün Adı'}</h2>
                <p className="product-description">{products[selectedProduct]?.description || 'Açıklama bulunamadı'}</p>
                
                <div className="product-details">
                  <h3>Özellikler</h3>
                  <ul className="features-list">
                    {(products[selectedProduct]?.features || []).map((feature, index) => (
                      <li key={index}>✓ {feature}</li>
                    ))}
                  </ul>
                  
                  <div className="specifications">
                    <h3>Teknik Özellikler</h3>
                    <div className="spec-item">
                      <strong>Boyutlar:</strong> {products[selectedProduct]?.dimensions || 'Belirtilmemiş'}
                    </div>
                    <div className="spec-item">
                      <strong>Malzeme:</strong> {products[selectedProduct]?.material || 'Belirtilmemiş'}
                    </div>
                    <div className="spec-item">
                      <strong>Garanti:</strong> {products[selectedProduct]?.warranty || 'Belirtilmemiş'}
                    </div>
                    <div className="spec-item price">
                      <strong>Fiyat:</strong> {products[selectedProduct]?.price || 'Fiyat için iletişime geçin'}
                    </div>
                  </div>
                  
                  <div className="action-buttons">
                    <a href="tel:+905496250335" className="btn btn-primary">
                      📞 Fiyat Bilgisi Al
                    </a>
                    <a href="https://wa.me/905496250335" target="_blank" rel="noopener noreferrer" className="btn btn-secondary">
                      <FaWhatsapp style={{ marginRight: 8 }} size={25}/>
                      WhatsApp
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default YatasYatak;
